<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "Pos Raporu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable
  },
  mixins: [ datatableMixin],
  data() {
    const end = new Date()
    const start = new Date()
    start.setDate(end.getDate() - 30)
    const ymd = (d) => {
      const p = (n) => String(n).padStart(2, '0')
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    }
    const form = { startdate: ymd(start), startdateend: ymd(end) }
    return {
      title: "POS RAPORU",
      items: [
      {
        text: "ANASAYFA",
        href: "/",
      },
      {
        text: "POS RAPORU",
        active: true,
      }],

        searchParams: { ...form },
        columns: [
            { name: 'Referans No', key: 'reff_number' },
            { name: 'Kullanıcı Adı', key: 'username' },
            { name: 'Ödeme Sonucu', key: 'status' },
            { name: 'Ödeme Detayı', key: 'payment_detail' },
            { name: 'Tutar', key: 'total_amount' },
            { name: 'Tiko', key: 'tiko', width: 130 },
            { name: 'Dekont Id', key: 'dekont_id' },
            { name: 'İşlem Tarihi', key: 'created_at', className: 'text-end',  width: 150   }
        ],
        tableData: {
            detail: true,
            searchable:{
            visible:true,
            placeholder:"İsim Soyisim Ara"
            }
        },
        endpoint: '/reports/pos-raporu',  
        form,
        rows: [],
        tikoModal: false,
        tikoLoading: false,
        tikoResult: null,
        tikoError: '',
    };
  },
  methods: {
    async loadPage() {
      this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
      
      const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
      if (this.params.page === 1) {
          this.tableData.data = response.data.data;
      } else {
          this.tableData.data = [...this.tableData.data, ...response.data.data];
      } 

      this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
      this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
    },
    handleFilterChange() {
      this.searchParams = this.form
      this.loadPage()
    },
    tikoKontrol(row) {
      this.tikoModal = true
      this.tikoLoading = true
      this.tikoResult = null
      this.tikoError = ''
      this.$http.post('/reports/pos-tiko', { reff_number: row.reff_number })
        .then(res => { this.tikoResult = res.data || {} })
        .catch(err => { this.tikoError = (err.response && err.response.data && err.response.data.message) || 'Sorgu başarısız' })
        .finally(() => { this.tikoLoading = false })
    }
  },
  computed: {
    tikoOzet() {
      const r = this.tikoResult || {}
      const result = r.Result || r.result || {}
      const status = String(result.Status || result.status || '')
      return {
        sorgu: r.Status || r.status || '-',
        odeme: status === '200' ? 'Başarılı' : (status === '100' ? 'Beklemede' : (status ? 'Başarısız (' + status + ')' : '-')),
        tutar: result.Amount || r.Amount || '-',
        transId: result.TransId || r.TransId || '-',
        aciklama: result.Description || r.Description || '-'
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <Datatable 
        :columns="columns" 
        :tableData="tableData" 
        @sort-column="handleSortColumn"
        @search-query="reLoadPage"
        @excel-export="excelExport"
        :loading="isLoading"
        :poading="pageLoading">
          
          <template #tiko="{ row }">
            <button type="button" class="btn btn-sm btn-outline-primary text-nowrap" @click="tikoKontrol(row)">Kontrol et</button>
          </template>

          <template #status="{ row }">
            <span v-if="row.status" class="badge rounded-pill bg-success"><i class="fa fa-check"></i>  Başarılı</span>
            <span v-else>Beklemede</span>
          </template>

          <template #searchItems="{ row }">
            <div class="col-md-4">
              <div class="row">
                <div class="col-xl-8">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label class="d-flex justify-content-between">İşlem Tarih Aralığı
                        <span 
                          v-if="form.startdate || form.startdateend" 
                          class="text-danger" 
                          @click="form.startdate= '' ;form.startdateend= ''">
                          temizle</span>
                        </label>
                       <div class="input-group">
                          <input type="date" class="form-control"  v-model="form.startdate" @change="handleFilterChange">
                          <button style="border:0;background: transparent;">  - </button>
                          <input type="date" class="form-control"  v-model="form.startdateend" @change="handleFilterChange">
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </template>
     </Datatable>

    <b-modal v-model="tikoModal" title="Tiko ödeme kontrolü" hide-footer>
      <div v-if="tikoLoading">Sorgulanıyor...</div>
      <div v-else-if="tikoError" class="text-danger">{{ tikoError }}</div>
      <table v-else class="table table-sm mb-0">
        <tr><th>Sorgu</th><td>{{ tikoOzet.sorgu }}</td></tr>
        <tr><th>Ödeme</th><td>{{ tikoOzet.odeme }}</td></tr>
        <tr><th>Tutar</th><td>{{ tikoOzet.tutar }}</td></tr>
        <tr><th>TransId</th><td>{{ tikoOzet.transId }}</td></tr>
        <tr><th>Açıklama</th><td>{{ tikoOzet.aciklama }}</td></tr>
      </table>
    </b-modal>
</Layout>
</template>